/**
 * Formatadores centralizados de moeda e percentual.
 *
 * Valores monetários de Oportunidade/Orçamento/Proposta usam 4 casas decimais.
 * Percentuais (imposto, margem) usam 2 casas decimais.
 */

function toNumber(value: number | string): number {
    if (typeof value === 'number') return value;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
}

export function formatCurrencyBRL(value: number | string, decimals: number = 4): string {
    const n = toNumber(value);
    // Sempre mostra no mínimo 2 casas; só exibe a 3ª/4ª casa quando o valor
    // realmente tem precisão além de 2 (ex: 45,9500 -> 45,95 | 45,953 -> 45,953)
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: Math.min(2, decimals),
        maximumFractionDigits: decimals,
    }).format(n);
}

export function formatPercent(value: number | string, decimals: number = 2): string {
    const n = toNumber(value);
    return `${n.toFixed(decimals)}%`;
}

export function roundTo(value: number | string, decimals: number = 4): number {
    const n = toNumber(value);
    const factor = 10 ** decimals;
    return Math.round((n + Number.EPSILON) * factor) / factor;
}
